// config.reducer.ts
import { createReducer, on } from '@ngrx/store';

import { loadComponentConfigFailure, loadComponentConfigSuccess } from './component-config.actions';

export interface ComponentConfigState {
  loaded: boolean;
  config: any;
  error: any;
}

export const initialState: ComponentConfigState = {
  loaded: false,
  config: null,
  error: null
};

export const componentConfigReducer = createReducer(
  initialState,
  on(loadComponentConfigSuccess, (state, { config }) => ({ ...state, config, loaded: true })),
  on(loadComponentConfigFailure, (state, { error }) => ({ ...state, error, loaded: true }))
);
